/*
 * @Descripttion: 项目入口
 * @version: 
 * @Author: liu yang
 * @Date: 2019-07-08 10:44:22
 * @LastEditors: liuyang5
 * @LastEditTime: 2020-04-22 09:07:29
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'emf/dist/js/util/util-nativepi'
import 'swiper/dist/css/swiper.css';
import Toast from '@/components/toast';
import Alert from '@/components/alert';
import SentryCenter from './utils/sentryCenter.vue.1.0.1';

const env = process.env.VUE_APP_TITLE === 'prod' ? 'Prod' : 'Test';
SentryCenter.startSentry('https://f83c26d35b7641569233e47929af72c9@fenewmonitor.eastmoney.com/44', env);
Vue.prototype.SentryCenter = SentryCenter;
Vue.use(Toast); // 使用全局toast组件
Vue.use(Alert); // 使用全局alert组件
Vue.use(VueAwesomeSwiper /* { default global options } */ )
Vue.config.productionTip = false
router.afterEach(() => {
  // 路由切换，页面滚动到顶部
  window.scrollTo(0, 0)
})
Vue.config.devtools = true
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')